import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutConfirmationService {
  private readonly showModalSubject = new BehaviorSubject<boolean>(false);
  public showModal$ = this.showModalSubject.asObservable();

  showLogoutModal(): void {
    this.showModalSubject.next(true);
  }

  hideLogoutModal(): void {
    this.showModalSubject.next(false);
  }
}
